<template>
  <div id="ui-view">
    <div>
      <div class="">
        <div class="">
          <strong><img :src="company_logo" style="height: 35px;" /></strong>
          <a
            href="#"
            class="btn btn-sm btn-info float-right printpage"
            onclick="javascript:window.print();"
            style="margin-top: 10px;"
          >
            <i class="fa fa-print"></i> Print</a
          >
        </div>
        <div class="">
          <div class="row">
            <div class="col-md-7"></div>            
           <div class="col-md-5 page">
               <table id="customers">
                  <tbody>
                    <tr>
                    <th class="blackbold">No.</th>
                    <th class="blackbold">Months</th>
                    <th class="blackbold">Monthly Pay </th>
                    <th class="blackbold">Date</th>
                    <th class="blackbold">Signature</th>
                    </tr>
                    <tr v-for="(row, index) in rows"  >
                       <td class="left" v-if="printdata.includes(row.id) ">
                       {{ index + 1 }}
                      </td>
                       <td class="left" style="color:#ffffff00" v-else>{{ index + 1 }}</td>
                       <td class="left" v-if="printdata.includes(row.id) ">
                        {{ row.pay_month }}
                      </td>
                       <td class="left" v-else></td>
                      <td class="left" v-if="printdata.includes(row.id) ">
                        <i class="fa fa-inr" aria-hidden="true"></i> {{ row.pay_monthly }}
                      </td>
                       <td class="left" v-else></td>
                      
                      <td class="left" v-if="printdata.includes(row.id) ">
                      {{ row.pay_date }}
                      </td>
                      <td class="left" v-else></td>
                      <td class="left" v-if="printdata.includes(row.id) "></td>
                      <td class="left" v-else></td>
                    </tr>
                  </tbody>
                </table>

            </div>
            
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
        selectcompany: null,
      access_token: null,
      printdata: JSON.parse(localStorage.getItem('printentry')),
      rows: [],
      company_logo: "",
       customercard: {
            ledgerno: null,
            monthlypay: null,
            openingmonth: null,
            closingmonth:null,
            closingyear:null,
            companyname:null,
            closingndate:null,
            schemename: null,
            createddate:null,
            schememonths: null,
            schemebonusmonths: null,
            schemefirmbonusmonths :null,
            openingyear: null,
            customername: null,
            address1: null,
            address2: null,
            customer_id:null,
            email:null,
            mobile:null,
          
           
          },
           cardData:{
                    pay_month:'',
                    pay_monthly:'',
                    recieved_by:'',
                    recieved_date:new Date().toISOString().slice(0,10),
                    card_wallet:'',
                    pay_mode :'',
                    status: '',

                },
      addressModel: false,
      cust_name: "",
      cust_email: "",
      cust_phone: "",
      cust_country: "",
      cust_state: "",
      cust_city: "",
      total_in_words: "",
      shop: {
        name: null,
        add1: null,
        add2: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        gst: null,
        phone: null,
      },
      customer1: {
        ship_id: null,
        name: null,
        add: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone: null,
      },
      customer: {
        name: null,
        add1: null,
        add2: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone: null,
        email: null,
        gst: null,
        pan: null,
        cin: null,
        tan: null,
        cust_name: null,
        cust_email: null,
        cust_phone: null,
        cust_country: null,
        cust_city: null,
        cust_state: null,
      },
      sales: {
        id: null,
        total_amt_pay: null,
        total_items_disc: null,
        additional_discount: null,
        total_amt_before_disc: null,
        cgst: null,
        sgst: null,
        igst: null,
        date: null,
        total_discount: "0.00",
        total_amt_paid: null,
        balance: null,
      },
      addr: [],
      cmp: {
        cmp_swift: null,
        cmp_bnk_holder: null,
      },
      amt_word: null,
      total_in_words: "",
    };
  },
  created() {
    // var _this = this;
    // var timer = setInterval(function () {
    //   if ("cid" in _this.$route.query && "sid" in _this.$route.query) {
    //     clearInterval(timer);
    //     var cid = _this.$route.query.cid;
    //     var sid = _this.$route.query.sid;
    //     _this.loadData(cid, sid);
    //     console.log('CID:'+cid+'SID:'+sid+'Test'+_this.$route.query)
    //   }
    // }, 600);
    this.show_carddetail();    
    this.show_card_entry();
  },
  methods: {
      
      
      show_carddetail(){

       var filteParam = {};
      //  filteParam.page = this.serverParams2.page;
      // filteParam.perPage = this.serverParams2.perPage;
      // filteParam.sort = this.serverParams2.sort;
         this.card_id = JSON.parse(localStorage.getItem('card_id'));
         var _this = this;
      //this.temprow = row;
      // var data =[]
      var data = "&filter[where][card_id]=" + this.card_id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/customercards/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          if (response.data != undefined) {
            _this.totalRecords1 = response.data[0].totalRecords;
            response.data.shift();
           // _this.rows1 = response.data;
             _this.customercard.ledgerno = response.data[0].ledger_no
             _this.customercard.monthlypay = response.data[0].monthly_pay
             _this.customercard.openingmonth = response.data[0].opening_month
             _this.customercard.openingyear = response.data[0].opening_year
               _this.customercard.closingmonth = response.data[0].closing_month
             _this.customercard.closingyear = response.data[0].closing_year
             _this.customercard.customername = response.data[0].cust_cmp_name
             _this.customercard.address1 = response.data[0].address1
              _this.customercard.address2 = response.data[0].address2
              _this.customercard.mobile = response.data[0].cust_cmp_phone
              _this.customercard.email = response.data[0].cust_cmp_email
             _this.customercard.customer_id = response.data[0].customer_id
             _this.cardData.pay_monthly = response.data[0].monthly_pay
             _this.cardData.status = response.data[0].status
              _this.customercard.companyname = response.data[0].company_name
            // _this.cardData.card_wallet = response.data[0].total_card_amount
            //  _this.cardCloseData.est_shop_id = response.data[0].est_shop_id
            //  _this.cardCloseData.scheme_id = response.data[0].scheme_id
             _this.customercard.schemename = response.data[0].scheme_name
             _this.customercard.schememonths = response.data[0].scheme_months
             _this.customercard.schemebonusmonths = response.data[0].scheme_bonus_months
              var today1 = new Date(response.data[0].created_date);
            var dd = today1.getDate();
            var mm = today1.getMonth() + 1; //January is 0!
            var yyyy = today1.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            today1 = dd + "-" + mm + "-" + yyyy;
             _this.customercard.createddate = today1
             _this.customercard.schemefirmbonusmonths = response.data[0].scheme_firm_bonus_months
            //_this.show_card_entry();
            //_this.show_carddetail();

        //   console.log(response.data[0])
          }
        });
    },
     show_card_entry(){
       var _this=this
         var filteParam = {};
      //  filteParam.page = this.serverParams2.page;
      // filteParam.perPage = this.serverParams2.perPage;
      // filteParam.sort = this.serverParams2.sort;
         this.card_id = JSON.parse(localStorage.getItem('card_id'));
      // this.$http.get('/api/customermonthentries/CustomerCards')
      
      
       var data = "&filter[where][card_id]=" + this.card_id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/customermonthentries/CustomerCards?params=" +
            JSON.stringify(filteParam) +
            data
        ).then(function (response) {
       _this.rows =response.data
        // console.log(response.data)
    
      })
      .catch(function (error) {

      });
      
    },
    loadData(cid, sid) {
      // if(localStorage.authUser != null){
      //   this.access_token = '?access_token='+localStorage.authUser
      // }
      this.customer_id = cid;
      this.shopuser();
      var data = [];
      var _this = this;

      this.$http
        .get("/api/companydetails/findOne")
        .then(function (response) {
          if (response.data.cmp_logo == null || response.data.cmp_logo == "") {
            _this.company_logo = "";
          } else {
            _this.company_logo =
              _this.$http.defaults.baseURL +
              "/api/containers/pics/download/" +
              response.data.cmp_logo +
              _this.access_token;
          }
        })
        .catch(function (error) {});
      this.$http
        .get(
          "/api/customershippspecs?filter[where][customer_id]=" +
            this.customer_id
        )
        .then(function (response) {
          var addr_data = response.data["ship_dt"];
          var state_dt = response.data["state_dt"];
          var city_dt = response.data["city_dt"];
          // var addr_data = response.data
          for (var i = 0; i < addr_data.length; i++) {
            _this.addr.push({
              yname: addr_data[i].customer_name,
              yaddress: addr_data[i].address,
              ypincode: addr_data[i].pincode,
              ystate: state_dt[addr_data[i].state_code],
              ystateid: addr_data[i].state_code,
              ycityid: addr_data[i].city,
              ycity: city_dt[addr_data[i].city],
              yphn: addr_data[i].contact_no,
              chkship_id: addr_data[i].shipp_id,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      //if(this.$router.query != undefined){
      var _this = this;
      var data = {};
      // Todays Date Start

      // Todays Date Ends

      // data.saleid = this.$router.props[0]
      // data.customer_id = this.$router.props[1]
      data.saleid = sid;
      data.customer_id = cid;
      this.$http
        .post("/api/saledetails/generate_invoice", data)
        .then(function (response) {
          _this.rows = response.data;
          // console.log("<br>")
          // console.log(response.data)
          // console.log("----------------------")
          for (var i = 0; i < _this.rows.length; i++) {
            _this.rows[i]["item_discount"] = 0.0;
            if (
              _this.rows[i]["disc_pct"] !== "" &&
              _this.rows[i]["disc_pct"] !== null &&
              _this.rows[i]["disc_pct"] !== undefined &&
              _this.rows[i]["disc_pct"] !== "0.000000"
            ) {
              // console.log( _this.rows[i]['disc_pct'])
              _this.rows[i]["item_discount"] =
                (parseInt(_this.rows[i]["disc_pct"]) / 100) *
                (parseFloat(_this.rows[i]["sale_qty"]) *
                  parseFloat(_this.rows[i]["product_unit_cost"]));
            }

            if (
              _this.rows[i]["disc_amt"] !== "" &&
              _this.rows[i]["disc_amt"] !== null &&
              _this.rows[i]["disc_amt"] !== undefined &&
              _this.rows[i]["disc_amt"] !== "0.000000"
            ) {
              // console.log( _this.rows[i]['disc_amt'])
              _this.rows[i]["item_discount"] = parseFloat(
                _this.rows[i]["disc_amt"]
              );
            }
          }

          if (response.data[0] != undefined) {
            // Company Details
            var total_item_disc = 0.0;
            var additional_discount = 0.0;
            var total_paid = 0.0;
            _this.cmp.cmp_swift = response.data[0].cmp_swift;
            _this.cmp.cmp_bnk_holder = response.data[0].cmp_bnk_holder;
            _this.cust_name = response.data[0].cust_cmp_name;
            _this.cust_email = response.data[0].cus_email;
            _this.cust_phone = response.data[0].cus_phone;
            _this.word(response.data[0].total_amt_pay);
            _this.customer.city = response.data[0].cus_city;
            _this.customer.state = response.data[0].cus_state;
            _this.customer.country = response.data[0].cus_cnty;
            _this.customer.pincode = response.data[0].cus_pincode;
            _this.customer.add1 = response.data[0].cus_add1;
            _this.customer.add2 = response.data[0].cus_add2;
            _this.customer.gst = response.data[0].cus_gst;
            _this.customer.pan = response.data[0].cus_pan;
            _this.customer.cin = response.data[0].cus_cin;
            _this.customer.tan = response.data[0].cus_tan;
            _this.customer1.ship_id = response.data[0].ship_id;
            _this.customer1.country = response.data[0].ship_country;
            _this.customer1.name = response.data[0].ship_customer_name;
            _this.customer1.add = response.data[0].ship_address;
            _this.customer1.city = response.data[0].ship_city;
            _this.customer1.state = response.data[0].ship_state;
            _this.customer1.pincode = response.data[0].ship_pincode;
            _this.customer1.phone = response.data[0].ship_contact_no;

            // Sales Details
            _this.sales.id = response.data[0].sales_id;
            _this.sales.total_amt_pay = parseFloat(
              response.data[0].total_amt_pay
            ).toFixed(2);
            total_item_disc = parseFloat(response.data[0].total_items_disc);
            _this.sales.total_items_disc = parseFloat(
              response.data[0].total_items_disc
            ).toFixed(2);
            _this.sales.cgst = parseFloat(response.data[0].cgst_amt).toFixed(2);
            _this.sales.sgst = parseFloat(response.data[0].sgst_amt).toFixed(2);
            _this.sales.igst = parseFloat(response.data[0].igst_amt).toFixed(2);
            _this.sales.total_amt_before_disc = parseFloat(
              response.data[0].total_amt_before_disc
            ).toFixed(2);
            additional_discount = parseFloat(
              response.data[0].additional_discount
            );
            _this.sales.additional_discount = parseFloat(
              response.data[0].additional_discount
            ).toFixed(2);
            _this.sales.total_discount = parseFloat(
              total_item_disc + additional_discount
            ).toFixed(2);

            total_paid =
              parseFloat(response.data[0].total_amt_pay) -
              parseFloat(response.data[0].total_amt_pendingpay);
            _this.sales.total_amt_paid = parseFloat(total_paid).toFixed(2);
            _this.sales.balance = parseFloat(
              response.data[0].total_amt_pendingpay
            ).toFixed(2);

            var today = new Date(response.data[0].sale_entry_date);
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            today = dd + "/" + mm + "/" + yyyy;
            _this.sales.date = today;
            // Shop Details
            _this.shop.name = response.data[0].shp_name;
            _this.shop.add1 = response.data[0].shp_add1;
            _this.shop.add2 = response.data[0].shp_add2;
            _this.shop.city = response.data[0].shp_city;
            _this.shop.state = response.data[0].shp_state;
            _this.shop.country = response.data[0].shp_cnty;
            _this.shop.pincode = response.data[0].shp_pin;
            _this.shop.gst = response.data[0]._this.shop.phone =
              response.data[0].shp_phone;

            // Customer Details
            _this.customer.name = response.data[0].cust_cmp_name;
            _this.customer.add1 = response.data[0].cus_add1;
            _this.customer.add2 = response.data[0].cus_add2;
            _this.customer.city = response.data[0].cus_city;
            _this.customer.state = response.data[0].cus_state;
            _this.customer.country = response.data[0].cus_cnty;
            _this.customer.pincode = response.data[0].cus_pincode;
            _this.customer.phone = response.data[0].cus_phone;
            _this.customer.email = response.data[0].cus_email;
            _this.customer.gst = response.data[0].cus_gst;
            _this.customer.pan = response.data[0].cus_pan;
            _this.customer.cin = response.data[0].cus_cin;
            _this.customer.tan = response.data[0].cus_tan;
            _this.word(response.data[0].total_amt_pay);
            _this.customer1.name = response.data[0].cust_cmp_name;
            _this.customer1.add = response.data[0].cus_add1;
            _this.customer1.city = response.data[0].cus_city;
            _this.customer1.state = response.data[0].cus_state;
            _this.customer1.pincode = response.data[0].cus_pincode;
            _this.customer1.phone = response.data[0].cus_phone;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      //}
    },

    shopuser() {
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    formatAmt(value) {
      return parseFloat(value).toFixed(2);
    },
    showAddress(adrs) {
      this.customer1.name = adrs.yname;
      this.customer1.add = adrs.yaddress;
      this.customer1.city = adrs.ycity;
      this.customer1.phone = adrs.yphn;
      this.customer1.state = adrs.ystate;
      this.customer1.pincode = adrs.ypincode;
      this.addressModel = false;
    },
    word(amt) {
      // console.log("AMT IN WORDS")
      // console.log(amt)
      var _this = this;
      var string = _this.inWords(parseInt(amt));
      _this.amt_word = string;
      // console.log(_this.amt_word)
    },

    inWords(num) {
      var a = [
        "",
        "One ",
        "Two ",
        "Three ",
        "Four ",
        "Five ",
        "Six ",
        "Seven ",
        "Eight ",
        "Nine ",
        "Ten ",
        "Eleven ",
        "Twelve ",
        "Thirteen ",
        "Fourteen ",
        "Fifteen ",
        "Sixteen ",
        "Seventeen ",
        "Eighteen ",
        "Nineteen ",
      ];
      var b = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if ((num = num.toString()).length > 9) return "overflow";
      var n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      var str = "";
      str +=
        n[1] != 0
          ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore "
          : "";
      str +=
        n[2] != 0
          ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh "
          : "";
      str +=
        n[3] != 0
          ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand "
          : "";
      str +=
        n[4] != 0
          ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred "
          : "";
      str +=
        n[5] != 0
          ? (str != "" ? "and " : "") +
            (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
            "Only "
          : "";
      return str;
    },
  },
};
</script>

<style type="text/css">
.editpencial {
  display: none !important;
}

.my-3 {
  padding-top: 5px !important;
}
.mbt-4 {
  margin-top: 15px !important;
}

@media print {
  .blackbold{
    color: #000000 !important;
    font-weight: 680 !important;
  }

  .breadcrumb {
    display: none;
  }
  .printpage {
    display: none;
  }
}

#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #03a9f4;
  color: white;
}

@media print
{    
    .card-header
    {
        display: none !important;
    }
    .app-footer {
    display: none;
  }
   @page 
    {
        size: auto;   /* auto is the initial value */
        margin: 0mm;  /* this affects the margin in the printer settings */
    }

    .page
    {
      margin-top: 120px !important;
      margin-left: 600px !important;
    }
}

.table td{
    border: none;
}

</style>


// WEBPACK FOOTER //
// src/views/gold/cardentrypdf.vue